module.exports = __webpack_public_path__ + "img/Background-Postcards-2366x901.a6d1c141.jpeg";